module.exports = __webpack_public_path__ + "static-portal/img/57-1.67b4549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/57-1.jpg
// module id = ZwMf
// module chunks = 4